import styled from "styled-components";
import { style } from "../style";

export const RoundButcon = styled.button`
  all: unset;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${style.colors.white};
  border: 1px solid ${style.colors.grey.primary};
  border-radius: 50%;

  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};

  width: 2rem;
  height: 2rem;

  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);

  &:hover {
    background: ${style.colors.grey.lightest};
  }

  &:active {
    background: ${style.colors.grey.light};
    box-shadow: unset;
  }

  &:focus-visible {
    outline: ${style.vars.borderWidth.base} dotted ${style.colors.grey.dark};
    outline-offset: 1px;
  }
`;
